export interface VideoItem {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  description: string;
  rating: number;
  year: number;
  duration: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  views: string;
}

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'kids', name: '少儿', icon: 'ri-star-smile-line' },
];

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '流浪地球3',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20futuristic%20spaceship%20and%20Earth%20in%20background%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20epic%20scale%2C%20movie%20poster%20style%20with%20Chinese%20title%20space%20at%20top&width=640&height=360&seq=boluo-v1&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，一群勇敢的年轻人挺身而出，为人类的未来而战。',
    rating: 9.2,
    year: 2026,
    duration: '148分钟',
    tags: ['科幻', '冒险', '灾难', '国产'],
    isHot: true,
    isNew: true,
    views: '2.8亿',
  },
  {
    id: 'v2',
    title: '狂飙',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20dark%20moody%20atmosphere%20with%20city%20night%20scene%2C%20two%20men%20in%20suits%20facing%20off%2C%20film%20noir%20style%2C%20dramatic%20lighting&width=640&height=360&seq=boluo-v2&orientation=landscape',
    description: '一部扫黑除恶坚决斗争的回忆录，横跨二十年的群像叙事全景式展现时代变迁下的黑白较量与复杂人性。',
    rating: 9.5,
    year: 2023,
    duration: '39集',
    tags: ['犯罪', '剧情', '扫黑', '国产'],
    isHot: true,
    isNew: false,
    views: '5.2亿',
  },
  {
    id: 'v3',
    title: '乘风破浪的姐姐 第五季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20performance%20with%20colorful%20lights%20and%20female%20performers%2C%20glamorous%20stage%20design%2C%20entertainment%20show%20aesthetic%2C%20vibrant%20and%20energetic&width=640&height=360&seq=boluo-v3&orientation=landscape',
    description: '30位30+姐姐重新出发，勇敢追逐舞台梦想，用实力破浪前行，展现女性无限魅力。',
    rating: 8.8,
    year: 2025,
    duration: '12期',
    tags: ['真人秀', '音乐', '竞演', '女性'],
    isHot: true,
    isNew: true,
    views: '3.5亿',
  },
  {
    id: 'v4',
    title: '深海',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20underwater%20scene%20with%20colorful%20coral%20reef%20and%20magical%20creatures%2C%20dreamy%20atmosphere%2C%20beautiful%20particle%20effects%2C%20artistic%20animation%20style&width=640&height=360&seq=boluo-v4&orientation=landscape',
    description: '一个少女误入梦幻深海世界，在神秘海底展开了一段独特的冒险旅程，画面美轮美奂。',
    rating: 8.7,
    year: 2023,
    duration: '112分钟',
    tags: ['动画', '奇幻', '冒险', '国产'],
    isHot: false,
    isNew: false,
    views: '1.6亿',
  },
  {
    id: 'v5',
    title: '地球脉动 第三季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20stunning%20landscape%20wildlife%20animals%20in%20natural%20habitat%2C%20BBC%20style%20cinematography%2C%20dramatic%20sunset%20lighting%2C%20epic%20scale&width=640&height=360&seq=boluo-v5&orientation=landscape',
    description: '从深海到雪山，从丛林到沙漠，用最震撼的镜头记录地球上最壮丽的自然奇观和动物迁徙。',
    rating: 9.8,
    year: 2024,
    duration: '8集',
    tags: ['自然', '动物', '地理', 'BBC'],
    isHot: false,
    isNew: false,
    views: '1.2亿',
  },
  {
    id: 'v6',
    title: '满江红',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20Chinese%20architecture%20and%20soldiers%2C%20dark%20red%20and%20black%20color%20scheme%2C%20dramatic%20composition%2C%20film%20poster%20design&width=640&height=360&seq=boluo-v6&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群小人物前赴后继，用生命揭开了一段被尘封的秘密。',
    rating: 8.3,
    year: 2023,
    duration: '159分钟',
    tags: ['历史', '悬疑', '喜剧', '国产'],
    isHot: true,
    isNew: false,
    views: '4.1亿',
  },
  {
    id: 'v7',
    title: '三体',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20with%20cosmic%20background%20and%20mysterious%20radio%20telescope%2C%20three%20body%20problem%20theme%2C%20dark%20and%20mysterious%20atmosphere%2C%20high%20production%20value&width=640&height=360&seq=boluo-v7&orientation=landscape',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘组织"科学边界"，揭开三体世界的秘密。',
    rating: 8.6,
    year: 2023,
    duration: '30集',
    tags: ['科幻', '悬疑', '小说改编', '国产'],
    isHot: true,
    isNew: false,
    views: '3.8亿',
  },
  {
    id: 'v8',
    title: '明星大侦探 第九季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Detective%20theme%20variety%20show%20set%20with%20mysterious%20room%20and%20clues%2C%20dramatic%20lighting%2C%20Chinese%20entertainment%20show%2C%20suspenseful%20atmosphere&width=640&height=360&seq=boluo-v8&orientation=landscape',
    description: '每期六位明星玩家，通过角色扮演和推理，在设定案情中寻找真凶，烧脑又搞笑。',
    rating: 9.0,
    year: 2025,
    duration: '12期',
    tags: ['推理', '真人秀', '悬疑', '搞笑'],
    isHot: false,
    isNew: true,
    views: '2.1亿',
  },
  {
    id: 'v9',
    title: '哪吒之魔童闹海',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20with%20mythological%20character%20Nezha%20with%20fire%20wheels%20and%20red%20ribbon%2C%20dramatic%20dynamic%20composition%2C%20epic%20fantasy%20style&width=640&height=360&seq=boluo-v9&orientation=landscape',
    description: '天劫之后，哪吒和敖丙面临魂飞魄散的危机。太乙真人想用七色宝莲为二人重塑肉身，却困难重重。',
    rating: 8.4,
    year: 2025,
    duration: '110分钟',
    tags: ['动画', '神话', '冒险', '国产'],
    isHot: true,
    isNew: true,
    views: '6.5亿',
  },
  {
    id: 'v10',
    title: '舌尖上的中国 第四季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20traditional%20Chinese%20cuisine%2C%20appetizing%20food%20photography&width=640&height=360&seq=boluo-v10&orientation=landscape',
    description: '穿越东西南北，探寻中华美食的根源与传承，讲述食物背后的人情故事和文化记忆。',
    rating: 9.3,
    year: 2024,
    duration: '8集',
    tags: ['美食', '文化', '人文', '国产'],
    isHot: false,
    isNew: false,
    views: '2.4亿',
  },
  {
    id: 'v11',
    title: '孤注一掷',
    category: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20dark%20atmosphere%20and%20computer%20screens%2C%20cyber%20crime%20theme%2C%20intense%20mood%2C%20modern%20thriller%20style&width=640&height=360&seq=boluo-v11&orientation=landscape',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱，展开了一场惊心动魄的逃生。',
    rating: 8.5,
    year: 2023,
    duration: '130分钟',
    tags: ['犯罪', '剧情', '社会', '国产'],
    isHot: false,
    isNew: false,
    views: '3.3亿',
  },
  {
    id: 'v12',
    title: '庆余年 第二季',
    category: 'tv',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20and%20handsome%20male%20lead%2C%20martial%20arts%20theme%2C%20epic%20costume%20design%2C%20dramatic%20composition&width=640&height=360&seq=boluo-v12&orientation=landscape',
    description: '范闲身世之谜逐渐揭开，他在庆国的权力漩涡中步步为营，既要保护至亲，又要探寻真相。',
    rating: 9.1,
    year: 2024,
    duration: '36集',
    tags: ['古装', '权谋', '武侠', '国产'],
    isHot: true,
    isNew: false,
    views: '4.6亿',
  },
];